import React from 'react';
import Select from 'react-select';
import provinces from '../../../constants/provinces';
import { withNamespaces } from 'react-i18next';

class DomesticArea extends React.Component {
  constructor(props) {
    super(props);

    this.changeProvinces = this.changeProvinces.bind(this);
  }

  changeProvinces(val) {
    const { request, changeRequest } = this.props;

    changeRequest(
      { ...request, domestic: { ...request.domestic, provinces: val } });
  }

  render() {
    const { request ,t} = this.props;

    return (
      <div className="row">
        <div className="col-md-12">
          <div className="form-group">
            <label>
              <span className="required-field">
*
              </span>
              {' '}{t("destinationCity")}
            </label>
            <Select
              multi
              placeholder={t("chooseCity")}
              options={provinces}
              value={request.domestic.provinces}
              onChange={this.changeProvinces}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withNamespaces()(DomesticArea);



// WEBPACK FOOTER //
// ./src/components/domestic/area/index.js